// extracted by mini-css-extract-plugin
export var chatHtmlText = "_tf-2";
export var chatLink = "_tf-0";
export var chatText = "_tf-1";